import { v4 } from 'uuid';

import { VolumeWithAsset } from '../../../react/components/skyview-new/components/report-tool-menu/helpers/utils';
import { ElementObj } from '../element-obj';
import { VolumeCalculationAssetTypeGuard } from './types';

export const getCompletedVolumes = (asset: ElementObj) => {
  if (!VolumeCalculationAssetTypeGuard.check(asset)) {
    return [];
  }

  return [...asset.cellGridVolumes, ...asset.prismVolumes].reduce((volumesWithAsset, volume) => {
    if (volume.isCompleted()) {
      volumesWithAsset.push({
        id: v4(),
        asset,
        volume,
        selected: asset.visible && asset.volumeHandler.isModelVisible(),
        sourceName: volume.getSourceName(),
        createdAt: volume.createdAt || new Date(),
      });
    }
    return volumesWithAsset;
  }, [] as VolumeWithAsset[]);
};
